<template>
  <div class="parking-record">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
    <template #name="{ row }">{{ row.name }}</template>
      <template #status="{ row }">{{ row.status }}</template>
      <template #plateNumber="{ row }">{{ row.plateNumber }}</template>
      <template #enterTime="{ row }">{{ row.enterTime ? $moment(row.enterTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #exitTime="{ row }">{{ row.exitTime ? $moment(row.exitTime).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #duration="{ row }">{{ row.duration }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="lookDetaile(scope.row)" >查看详情</el-button >
      </template>
    </Table>
  </div>
</template>
<script>
import AuthButton from '@/components/AuthButton'
import { api_getParkingRecordList } from '@/api/parking'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "parkingRecord",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          multiple: false,
          key: "status",
          option: [{
            label: '计费中',
            value: 'Billing'
          },{
            label: '已出场',
            value: 'Left'
          }],
        },
        {
          label: "入场时间",
          placeholder: ['起始时间', '截止时间'],
          type: "date-range",
          key: "parkTime",
        },
        {
          label: "车牌号",
          placeholder: "请输入车牌号",
          type: "input",
          key: "plateNumber",
        },
      ],
      form: {
      },
      tableThData: [
       { prop: "name", label: "停车场", minWidth: "150", },
        { prop: "plateNumber", label: "车牌号", minWidth: "130", },
        { prop: "status", label: "状态", minWidth: "130", },
        { prop: "enterTime", label: "入场时间", minWidth: "170", },
        { prop: "exitTime", label: "出场时间", minWidth: "170", },
        { prop: "duration", label: "停车时长（分）", minWidth: "150", },
        { prop: "operation", label: "操作", minWidth: "100", },
      ],
    };
  },
  created () {
    // this.getStatistics()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let newParams = {...params}
      if(newParams.parkTime && newParams.parkTime.length > 0){
        newParams.enterTimeFrom = +new Date(newParams.parkTime[0])
        newParams.enterTimeTo = +new Date(newParams.parkTime[1])
      }
      delete newParams.parkTime
      const data = await api_getParkingRecordList(newParams)
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    lookDetaile (row) {
      this.$router.push({
        path: `/parkMangement/paymentRecord/detail?id=${row.id}`
      })
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.parking-record {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  ::v-deep{
    .search-box{
      margin-top: 20px;
    }
  }
  .today-sum{
    margin-top: 35px;
    display: flex;
    justify-content: space-between;
    .today-sum-item{
      height: 90px;
      width: calc(50% - 7.5px);
      display: flex;
      align-items: center;
      .item-icon{
        margin-left: 50px;
        margin-right: 20px;
        img{
          width: 46px;
          height: 46px;
        }
      }
      .item-content{
        p{
          margin: 0;
        }
        .title{
          font-size: 12px;
          color: #666666;
          margin-bottom: 15px;
        }
        .amount{
          font-size: 24px;
          font-weight: 500;
          color: #333333;
        }
        .tips{
          font-size: 12px;
          color: #666666;
          font-weight: 400;
        }
      }
    }
  }
  .finance{
    height: 100px;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    box-sizing: border-box;
    display: flex;
    // min-width: 1150px;
  }
  .finance.first{
    margin-top: 35px;
  }
  .finance-div{
    // min-width: 1160px;
    overflow: auto;
  }
  *::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }
  *::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
    background: #dcdfe6;
  }
  *::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
    border-radius: 10px;
    background: #fafafa;
  }
  .dataItem{
    width: 230px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    img{
      width: 40px;
      height: 40px;
      margin-left: 20px;
    }
    .dataItem-content{
      margin-left: 10px;
      width: 154px;
      .dataItem-title{
        font-size: 12px;
        color: #666666;
        margin: 0;
        margin-bottom: 10px;
      }
      .dataItem-value{
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        margin: 0;
        span{
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          margin-left: 10px;
        }
      }
    }
    ::v-deep{
      .el-divider--vertical{
        height: 70px;
      }
    }
  }
  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
  }
  .Billing, .Paying{
    background: #3775FF;
    border-radius: 50%;
    vertical-align: middle;
  }
  .Left{
    background: #05c8af;
    border-radius: 50%;
    vertical-align: middle;
  }
  .tipsA{
    font-size: 13px;
    color: #FF8E12;
  }
  .tipsB{
    font-size: 13px;
    color: #999;
  }
  ::v-deep{
    .el-table__body-wrapper::-webkit-scrollbar{
      /*滚动条整体样式*/
      width: 4px !important; /*高宽分别对应横竖滚动条的尺寸*/
      height: 5px !important;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
      background: #dcdfe6;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
      border-radius: 10px;
      background: #fafafa;
    }
    .el-table__fixed{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
    .el-table__fixed-right{
      height: 100% !important;   //设置高优先，以覆盖内联样式
    }
  }
}
</style>
